module.exports = __webpack_public_path__ + "static/media/fantasy-3077928_1920_opt.ac8d8da7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/fantasy-3077928_1920_opt.jpg
// module id = 85
// module chunks = 0